<template>
  <!--Adding new SIMs -->
  <Modal v-if="popupTriggers.addSIMTrigger" :TogglePopup="() => TogglePopup('addSIMTrigger')">
    <div class="add-sims-dialog">
      <header class="add-sims-header"><h2>Add SIMs</h2></header>
      <section class="add-sims-section">
        <label for="textarea">SIM records</label>
        <p>Enter one SIM per line in this order: Number; Valid Until (YYYY-MM-DD); Operator; IMEI; Brand; Team / Legacy Pricing; Notes.</p>
        <textarea id="textarea" class="form-control add-sims-input" placeholder="+37251234567; 2027-08-19; operator; IMEI; Huntloc; Team; Notes"></textarea>
        <div class="add-sims-actions"><button class="btn add-sims-submit" @click="AddSIMs()">Add SIMs</button></div>
      </section>
    </div>
  </Modal>

  <SimDetailsModal
    :visible="popupTriggers.simDetailsTrigger"
    :sim="selectedSim"
    :team-display="getSimPricingModelDisplayValue(selectedSim)"
    :toggle-popup="() => TogglePopup('simDetailsTrigger')"
    @open-user="openOwnerDetails"
    @open-team="openTeamDetails"
  />

  <UserDetailsModal
    :visible="popupTriggers.userDetailsTrigger"
    :user="selectedDeviceOwner"
    :toggle-popup="() => TogglePopup('userDetailsTrigger')"
  />

  <div v-if="loadingOwnerImei" class="device-owner-loading-overlay" role="status" aria-live="polite">
    <div class="device-owner-loading-card">
      <div class="spinner-border" aria-hidden="true"></div>
      <p>Loading device owner...</p>
    </div>
  </div>

  <div class="col bg-light" style="width: 100%" v-if="loaded == false">
    <div class="lds-ring" style="margin-left: 50%; margin-top: 20%"><div></div><div></div><div></div><div></div></div>
  </div>
  <div v-else class="col bg-light sims-list-view">
    <header class="sims-list-header">
      <div>
        <h1>Trackers SIM management</h1>
      </div>
      <div class="sims-list-header-updated">Updated: {{ lastUpdated || '-' }}</div>
    </header>
    <!--Top area-->
    <div class="sims-list-toolbar">
      <!--Picking amount of entries shown-->
      <div class="sims-list-page-size">
        <label for="simEntries">Entries</label>
        <select id="simEntries" v-model="currentEntries" class="form-control form-control-sm" @change="paginateEntries">
          <option v-for="se in showEntries" :key="se" :value="se">
            {{ se }}
          </option>
        </select>
      </div>

      <!--Search bar to search every column at once-->
      <div class="sims-list-actions">
        <router-link to="/InternetRenewals" custom v-slot="{ navigate }">
          <span><button type="button" @click="navigate" class="btn sims-list-secondary">
            Internet extension notifications
          </button></span>
        </router-link>
        <span><button v-on:click="() => TogglePopup('addSIMTrigger')" class="btn sims-list-secondary">
          Add SIMS
        </button></span>
        <span><button @click="applyQuickFilter('expiresSoon')" class="btn sims-list-secondary">
          Expires Soon
        </button></span>
        <span><button @click="applyQuickFilter('expiredActive')" class="btn sims-list-secondary">
          Expired Active SIM
        </button></span>
        <span v-if="hasNewActivatedSims"><button @click="applyQuickFilter('newActivated')" class="btn sims-list-primary sims-list-new">
          New SIMs activated
        </button></span>
        <span><button @click="toggleValid()" class="btn sims-list-secondary">
            Valid SIMs:
            <small v-if="hidevalid == 'empty'">No</small>
            <small v-else-if="hidevalid == 'full'">Yes</small>
            <small v-else-if="hidevalid == ''">All</small>
          </button></span>
        <span><button @click="toggleDeleted()" class="btn sims-list-secondary">
            Deleted SIMs:
            <small v-if="hidedeleted == 'empty'">No</small>
            <small v-else-if="hidedeleted == 'full'">Yes</small>
            <small v-else-if="hidedeleted == ''">All</small>
          </button></span
        >
        <span
          ><button
            @click="downloadCSV()"
            class="btn sims-list-secondary"
          >
            Download CSV
          </button></span
        >
        <span
          ><button
            class="btn sims-list-secondary"
            @click="resetSims"
          >
            Reset filters
          </button></span
        >
        <span
          ><input
            class="search form-control form-control-sm sims-list-search"
            type="text"
            placeholder="Search.."
            v-model="searchInput"
            @keyup="searchEvent"
        /></span>
      </div>
    </div>

    <div class="sims-list-columns">
      <span class="table-filter-label me-2">Columns:</span>
      <label
        v-for="column in hideableColumns"
        :key="column.name"
        class="table-column-toggle"
      >
        <input
          :checked="isColumnVisible(column.name)"
          type="checkbox"
          class="form-check-input mt-0"
          @change="setColumnVisibility(column.name, $event.target.checked)"
        />
        <span>{{ column.text }}</span>
      </label>
    </div>

    <!--SIMs Tables-->
    <div class="sims-list-table-wrap">
    <table :class="['table table-hover sims-data-table', tableColumnVisibilityClasses]">
      <!--Rows for titles and filters-->
      <thead>
        <!--Table row for column titles-->
        <tr class="h6">
          <!--Contents that are sorted-->
          <th>
            <div class="d-flex justify-content-between">
              <span>Number</span>
              <span
                v-if="sortnumber == 'default'"
                @click.prevent="sortByColumn('phoneNumber')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortnumber == 'desc'"
                @click.prevent="sortByColumn('phoneNumber')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortnumber == 'asc'"
                @click.prevent="sortByColumn('phoneNumber')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Valid Until</span>
              <span
                v-if="sortvalid == 'default'"
                @click.prevent="sortByColumn('validUntil')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortvalid == 'desc'"
                @click.prevent="sortByColumn('validUntil')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortvalid == 'asc'"
                @click.prevent="sortByColumn('validUntil')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <th>
            <div class="d-flex justify-content-between">
              <span>Deleted</span>
              <span
                v-if="sortdeleted == 'default'"
                @click.prevent="sortByColumn('deleted')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortdeleted == 'desc'"
                @click.prevent="sortByColumn('deleted')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-up"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                  /></svg
              ></span>
              <span
                v-else-if="sortdeleted == 'asc'"
                @click.prevent="sortByColumn('deleted')"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-arrow-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                  /></svg
              ></span>
            </div>
          </th>
          <!--Rest of the content-->
          <th v-for="tc in tableColumns" :key="tc">
            <div>{{ tc.text }}</div>
          </th>
          <th>Actions</th>
        </tr>
        <!--Table row for column filters-->
        <tr>
          <th>
            <input
              type="search"
              class="form-control search"
              placeholder=""
              aria-label="Number"
              v-model="col.phoneNumber"
              @keyup="filterByColumn"
            />
          </th>

          <th>
            <div style="display: flex">
              <input
                type="search"
                class="form-control form-control-sm"
                v-model="col.validmin"
                @keyup="filterByColumn"
              />-<input
                type="search"
                class="form-control form-control-sm"
                v-model="col.validmax"
                @keyup="filterByColumn"
              />
            </div>
          </th>

          <th>
            <div style="display: flex">
              <input
                type="search"
                class="form-control form-control-sm"
                v-model="col.deletedmin"
                @keyup="filterByColumn"
              />-<input
                type="search"
                class="form-control form-control-sm"
                v-model="col.deletedmax"
                @keyup="filterByColumn"
              />
            </div>
          </th>

          <th>
            <div v-if="col.status.length == 0">
              <select
                class="form-select"
                v-model="col.status"
                @change="filterByColumn"
              >
                <option value=""></option>
                <option value="     ">Empty</option>
                <option value="Active">Active</option>
                <option value="New">New</option>
                <option value="Stopped">Stopped</option>
                <option value="Closed">Closed</option>
              </select>
            </div>

            <div v-else>
              <select
                class="form-select form-search"
                v-model="col.status"
                @change="filterByColumn"
              >
                <option value=""></option>
                <option value="     ">Empty</option>
                <option value="Active">Active</option>
                <option value="New">New</option>
                <option value="Stopped">Stopped</option>
                <option value="Closed">Closed</option>
              </select>
            </div>
          </th>

          <th>
            <div v-if="col.operator.length == 0">
              <select
                class="form-select"
                v-model="col.operator"
                @change="filterByColumn"
              >
                <option value=""></option>
                <option value="     ">Empty</option>
                <option value="Telia">Telia</option>
                <option value="TeliaSWE">TeliaSWE</option>
                <option value="TravelSIM">TravelSIM</option>
                <option value="1oT">1oT</option>
              </select>
            </div>

            <div v-else>
              <select
                class="form-select form-search"
                v-model="col.operator"
                @change="filterByColumn"
              >
                <option value=""></option>
                <option value="     ">Empty</option>
                <option value="Telia">Telia</option>
                <option value="TeliaSWE">TeliaSWE</option>
                <option value="TravelSIM">TravelSIM</option>
                <option value="1oT">1oT</option>
              </select>
            </div>
          </th>

          <th>
            <div class="d-flex justify-content-between">
              <span
                ><input
                  type="search"
                  class="form-control search"
                  placeholder=""
                  v-model="col.imei"
                  @keyup="filterByColumn"
              /></span>

              <div v-if="col.imei.length == 0">
                <span
                  ><select
                    class="form-select"
                    v-model="col.imei"
                    @change="filterByColumn"
                  >
                    <option value="">Default</option>
                    <option value="     ">Empty</option>
                  </select>
                </span>
              </div>

              <div v-else class="d-flex justify-content-between">
                <span
                  ><select
                    class="form-select form-search"
                    v-model="col.imei"
                    @change="filterByColumn"
                  >
                    <option value="">Default</option>
                    <option value="     ">Empty</option>
                  </select>
                </span>
              </div>
            </div>
          </th>

          <th>
            <div v-if="col.brand.length == 0">
              <select
                class="form-select"
                v-model="col.brand"
                @change="filterByColumn"
              >
                <option value=""></option>
                <option value="     ">Empty</option>
                <option value="Huntloc">Huntloc</option>
                <option value="Doglo">Doglo</option>
                <option value="Valve">Valve</option>
              </select>
            </div>

            <div v-else>
              <select
                class="form-select form-search"
                v-model="col.brand"
                @change="filterByColumn"
              >
                <option value=""></option>
                <option value="     ">Empty</option>
                <option value="Huntloc">Huntloc</option>
                <option value="Doglo">Doglo</option>
                <option value="Valve">Valve</option>
              </select>
            </div>
          </th>

          <th>
            <input
              type="search"
              class="form-control search"
              list="sim-team-filter-options"
              placeholder=""
              v-model="col.pricingModel"
              @input="filterByColumn"
            />
          </th>

          <th>
            <input
              type="search"
              class="form-control search"
              placeholder=""
              v-model="col.notes"
              @keyup="filterByColumn"
            />
          </th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="td in tableData" :key="td">
          <td>
            <div v-if="tagEditingId == td.id">
              <input
                id="phoneNumber"
                type="text"
                class="form-control"
                v-model="td.phoneNumber"
                :focusId="'tag-edit-${id}'"
                @keydown.enter="updateSimNumber(td)"
                @keydown.escape="resetEditing()"
              />
            </div>
            <div v-else @click="setTagEditingId(td.id)">
              {{ td.phoneNumber }}
            </div>
          </td>
          <td>
            <div v-if="tagEditingId == td.id">
              <input
                id="validUntil"
                class="form-control"
                type="date"
                v-model="td.validUntil"
                :focusId="'tag-edit-${id}'"
                @keydown.enter="updateSimNumber(td)"
                @keydown.escape="resetEditing()"
              />
            </div>
            <div v-else @click="setTagEditingId(td.id)">
              <span :class="getValidUntilClass(td.validUntil)">{{ td.validUntil }}</span>
            </div>
          </td>
          <td>
            <div v-if="tagEditingId == td.id">
              <input
                id="deleted"
                class="form-control"
                type="date"
                v-model="td.deleted"
                :focusId="'tag-edit-${id}'"
                @keydown.enter="updateSimNumber(td)"
                @keydown.escape="resetEditing()"
              />
            </div>
            <div v-else @click="setTagEditingId(td.id)">{{ td.deleted }}</div>
          </td>
          <td>
            <div v-if="tagEditingId == td.id">
              <select
                class="form-select"
                id="status"
                v-model="td.status"
                :focusId="'tag-edit-${id}'"
                @keydown.enter="updateSimNumber(td)"
                @keydown.escape="resetEditing()"
              >
                <option value="Active">Active</option>
                <option value="New">New</option>
                <option value="Stopped">Stopped</option>
                <option value="Closed">Closed</option>
              </select>
            </div>

            <div v-else @click="setTagEditingId(td.id)">
              <div v-if="td.status == 'Stopped'">
                <div v-bind:class="{ stopped: true }">{{ td.status }}</div>
              </div>
              <div v-else-if="td.status == 'Closed'">
                <div v-bind:class="{ closed: true }">{{ td.status }}</div>
              </div>
              <div v-else>{{ td.status }}</div>
            </div>
          </td>
          <td>
            <div v-if="tagEditingId == td.id">
              <select
                class="form-select"
                id="operator"
                v-model="td.operator"
                :focusId="'tag-edit-${id}'"
                @keydown.enter="updateSimNumber(td)"
                @keydown.escape="resetEditing()"
              >
                <option value="Telia">Telia</option>
                <option value="TeliaSWE">TeliaSWE</option>
                <option value="TravelSIM">TravelSIM</option>
                <option value="1oT">1oT</option>
              </select>
            </div>
            <div v-else @click="setTagEditingId(td.id)">{{ td.operator }}</div>
          </td>
          <td>
            <div v-if="tagEditingId == td.id">
              <input
                id="imei"
                type="text"
                class="form-control"
                v-model="td.imei"
                :focusId="'tag-edit-${id}'"
                @keydown.enter="updateSimNumber(td)"
                @keydown.escape="resetEditing()"
              />
            </div>
            <div v-else @click="setTagEditingId(td.id)">{{ td.imei }}</div>
          </td>
          <td>
            <div v-if="tagEditingId == td.id">
              <select
                class="form-select"
                id="brand"
                v-model="td.brand"
                :focusId="'tag-edit-${id}'"
                @keydown.enter="updateSimNumber(td)"
                @keydown.escape="resetEditing()"
              >
                <option value="Huntloc">Huntloc</option>
                <option value="Doglo">Doglo</option>
                <option value="Valve">Valve</option>
              </select>
            </div>
            <div v-else @click="setTagEditingId(td.id)">
              <span :class="getBrandClass(td.brand)">{{ td.brand }}</span>
            </div>
          </td>
          <td>
            <div v-if="tagEditingId == td.id">
              <input
                id="pricingModel"
                type="text"
                class="form-control"
                list="sim-team-options"
                v-model="td.pricingModelSelection"
                :focusId="'tag-edit-${id}'"
                @keydown.enter="updateSimNumber(td)"
                @keydown.escape="resetEditing()"
              />
            </div>
            <div v-else @click="setTagEditingId(td.id)">
              {{ getSimPricingModelDisplayValue(td) }}
            </div>
          </td>
          <td>
            <div v-if="tagEditingId == td.id">
              <input
                id="notes"
                type="text"
                class="form-control"
                v-model="td.notes"
                :focusId="'tag-edit-${id}'"
                @keydown.enter="updateSimNumber(td)"
                @keydown.escape="resetEditing()"
              />
            </div>
            <div v-else @click="setTagEditingId(td.id)">{{ td.notes }}</div>
          </td>
          <td>
            <div
              v-if="tagEditingId == td.id"
              class="d-flex justify-content-around"
            >
              <span
                ><button
                  class="mx-1 btn-outline-dark btn-rounded btn rounded-pill"
                  @click="updateSimNumber(td)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="11"
                    fill="currentColor"
                    class="bi bi-plus-lg"
                    viewBox="0 0 16 20"
                  >
                    <path
                      d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"
                    />
                  </svg></button
              ></span>
              <span
                ><button
                  class="btn-outline-dark btn-rounded btn rounded-pill"
                  @click="resetEditing()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="11"
                    fill="currentColor"
                    class="bi bi-dash-lg"
                    viewBox="0 0 16 20"
                  >
                    <path
                      d="M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z"
                    />
                  </svg></button
              ></span>
            </div>
            <div v-else class="d-flex justify-content-around">
              <span>
                <button
                  class="mx-1 btn-outline-dark btn-rounded btn rounded-pill"
                  title="Open SIM details"
                  aria-label="Open SIM details"
                  @click="showSimDetails(td)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="11"
                    fill="currentColor"
                    class="bi bi-info-lg"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14z" />
                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z" />
                    <circle cx="8" cy="4.5" r="1" />
                  </svg>
                </button>
              </span>
              <span
                ><button
                  class="mx-1 btn-outline-dark btn-rounded btn rounded-pill"
                  @click="setTagEditingId(td.id)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="11"
                    fill="currentColor"
                    class="bi bi-pen"
                    viewBox="0 0 16 20"
                  >
                    <path
                      d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"
                    />
                  </svg></button
              ></span>
              <span
                ><button
                  class="btn-outline-dark btn-rounded btn rounded-pill"
                  @click="removeSIM(td.id)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="11"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 20"
                  >
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg></button
              ></span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    </div>

    <datalist id="sim-team-filter-options">
      <option value="__EMPTY__">Empty</option>
      <option v-for="option in simPricingFilterOptions" :key="`sim-pricing-filter-${option}`" :value="option"></option>
    </datalist>

    <datalist id="sim-team-options">
      <option value=""></option>
      <option v-for="option in simPricingFilterOptions" :key="`sim-pricing-edit-${option}`" :value="option"></option>
    </datalist>

    <div class="d-flex d-flex justify-content-between mb-1">
      <div style="font-size: 12px">
        Show {{ showInfo.from }} to {{ showInfo.to }} of
        {{ showInfo.of }} entries
      </div>
      <div style="font-size: 10px">
        <ul class="list-group list-group-horizontal mb-1">
          <li
            :class="[
              'list-group-item border px-2',
              { disabled: currentPage === 1 },
            ]"
          >
            <a
              href="#"
              class="nav-link"
              @click.prevent="(currentPage = 1), paginateEntries()"
              >First</a
            >
          </li>
          <li
            :class="[
              'list-group-item border px-2',
              { disabled: currentPage === 1 },
            ]"
          >
            <a
              href="#"
              class="nav-link"
              @click.prevent="
                currentPage < 1 ? (currentPage = 1) : (currentPage -= 1),
                  paginateEntries()
              "
              >Prev</a
            >
          </li>
          <li
            v-for="pagi in showPagination"
            :key="pagi"
            :class="[
              'list-group-item border px-2',
              { ellipsis: pagi === '...', active: pagi === currentPage },
            ]"
          >
            <a
              href="#"
              class="nav-link bg-white text-dark"
              @click.prevent="paginateEvent(pagi)"
              >{{ pagi }}</a
            >
          </li>
          <li
            :class="[
              'list-group-item border px-2',
              { disabled: currentPage === allPages },
            ]"
          >
            <a
              href="#"
              class="nav-link"
              @click.prevent="
                currentPage > allPages
                  ? (currentPage = allPages)
                  : (currentPage += 1),
                  paginateEntries()
              "
              >Next</a
            >
          </li>
          <li
            :class="[
              'list-group-item border px-2',
              { disabled: currentPage === allPages },
            ]"
          >
            <a
              href="#"
              class="nav-link"
              @click.prevent="(currentPage = allPages), paginateEntries()"
              >Last</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, ref } from 'vue'
import * as $ from "alga-js";
import axios from "axios";
import Modal from "@/components/Modal.vue";
import UserDetailsModal from '@/components/UserDetailsModal.vue'
import SimDetailsModal from '@/components/SimDetailsModal.vue'
import { API_ENDPOINTS } from '@/config/api'
import {
  LEGACY_SIM_PRICING_MODELS,
  getSimTeamLinkDisplay,
  getStoredSimTeamLinkValue,
  getTeamLinkLabel
} from '@/utils/simTeamLink'

export default {
  name: "SimsTable",
  components: {
    Modal,
    SimDetailsModal,
    UserDetailsModal,
  },
  setup() {
    const popupTriggers = ref({ addSIMTrigger: false, simDetailsTrigger: false, userDetailsTrigger: false })
    const TogglePopup = (trigger) => { popupTriggers.value[trigger] = !popupTriggers.value[trigger]}
    const store = inject('store')
    return {
      Modal,
      popupTriggers,
      TogglePopup,
      store
    }
  },
  mounted() {
    this.$store.dispatch('loadSims')
  },
  data() {
    return {
      hidevalid: "",
      hidedeleted: "",
      sortnumber: "default",
      sortvalid: "default",
      sortdeleted: "default",
      stopped: false,
      closed: false,
      validSort: "",
      deletedSort: "",
      tagEditingId: "",
      loaded: false,
      lastUpdated: "",
      csvData: [],
      availableTeams: [],
      selectedSim: {},
      selectedDeviceOwner: {},
      loadingOwnerImei: '',
      deviceOwnerPhonesByImei: {},
      deviceOwnerUsersByPhone: {},
      columns: [
        { name: "status", text: "Status" },
        { name: "operator", text: "Operator" },
        { name: "imei", text: "IMEI" },
        { name: "brand", text: "Brand" },
        { name: "pricingModel", text: "Team" },
        { name: "notes", text: "Notes" },
      ],
      columnVisibility: {
        validUntil: true,
        deleted: true,
        status: true,
        operator: true,
        imei: true,
        brand: true,
        pricingModel: true,
        notes: true,
        actions: true,
      },
      entries: [],
      showEntries: [1, 5, 10, 15, 25, 50, 100, 250, 500, 1000, 1500],
      currentEntries: 50,
      filteredEntries: [],
      currentPage: 1,
      allPages: 1,
      searchInput: "",
      searchEntries: [],
      col: {
        phoneNumber: "",
        validmin: "",
        validmax: "",
        hasValidUntil: "",
        deletedmin: "",
        deletedmax: "",
        status: "",
        operator: "",
        imei: "",
        brand: "",
        pricingModel: "",
        notes: "",
      },
      sortcol: {
        phoneNumber: "",
        validUntil: "",
        deleted: "",
        status: "",
        operator: "",
        imei: "",
        brand: "",
        pricingModel: "",
        notes: "",
      },
    };
  },
  computed: {
    showInfo() {
      return $.array.pageInfo(
        this.getCurrentEntries(),
        this.currentPage,
        this.currentEntries
      );
    },
    showPagination() {
      return $.array.pagination(this.allPages, this.currentPage, 3);
    },
    tableColumns() {
      return this.columns;
    },
    hideableColumns() {
      return [
        { name: "validUntil", text: "Valid Until" },
        { name: "deleted", text: "Deleted" },
        ...this.columns,
        { name: "actions", text: "Actions" },
      ]
    },
    tableColumnVisibilityClasses() {
      return this.hideableColumns
        .filter((column) => this.columnVisibility[column.name] === false)
        .map((column) => `hide-column-${column.name}`)
    },
    tableData() {
      return this.filteredEntries;
    },
    hasNewActivatedSims() {
      return Array.isArray(this.defaultentries) && this.defaultentries.some((entry) => {
        return entry?.status === 'New' && !this.isBlankValue(entry?.validUntil)
      })
    },
    simTeamOptions() {
      const labels = this.availableTeams
        .map((team) => getTeamLinkLabel(team))
        .filter((label) => label.length > 0)
        .sort((leftLabel, rightLabel) => leftLabel.localeCompare(rightLabel, 'et', { sensitivity: 'base' }))

      return [...new Set(labels)]
    },
    simPricingFilterOptions() {
      return [...LEGACY_SIM_PRICING_MODELS, ...this.simTeamOptions]
    }
  },
  created() {
    this.getAllSims()
    this.getAllTeams()
  },
  methods: {
    formatUpdatedAt(date = new Date()) {
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${day}.${month}.${year} ${hours}:${minutes}`
    },
    isColumnVisible(columnName) {
      return this.columnVisibility[columnName] !== false
    },
    getDeviceOwnerApiBase() {
      if (typeof window !== 'undefined') {
        const hostname = String(window.location.hostname || '').toLowerCase()
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
          return 'http://localhost:3002/api'
        }
      }

      return API_ENDPOINTS.TIW_API || '/api'
    },
    findLoadedUserByPhoneNumber(phoneNumber) {
      const normalizedPhoneNumber = String(phoneNumber || '').replace(/\s+/g, '')
      const users = this.$store?.state?.users || this.store?.state?.users || []
      if (!normalizedPhoneNumber || !Array.isArray(users)) return null

      return users.find((user) => {
        const userPhoneNumber = String(user?.cellnumber || user?.phoneNumber || '').replace(/\s+/g, '')
        return userPhoneNumber === normalizedPhoneNumber
      }) || null
    },
    setColumnVisibility(columnName, isVisible) {
      this.columnVisibility[columnName] = isVisible
    },
    getSimPricingModelDisplayValue(sim) {
      return getSimTeamLinkDisplay(sim?.pricingModel, this.availableTeams)
    },
    getSimPricingModelSelectionValue(sim) {
      return this.getSimPricingModelDisplayValue(sim)
    },
    getStoredSimPricingModelSelection(selection) {
      return getStoredSimTeamLinkValue(selection, this.availableTeams)
    },
    isBlankValue(value) {
      return value == null || String(value).trim() === ""
    },
    parseDateString(dateString, endOfDay = false) {
      if (this.isBlankValue(dateString)) return null

      const parts = String(dateString).trim().split("-")
      if (parts.length !== 3) return null

      const [year, month, day] = parts.map((value) => Number(value))
      if (!year || !month || !day) return null

      return endOfDay
        ? new Date(year, month - 1, day, 23, 59, 59, 999)
        : new Date(year, month - 1, day, 0, 0, 0, 0)
    },
    formatDateOffset(offsetDays = 0) {
      const date = new Date()
      date.setHours(0, 0, 0, 0)
      date.setDate(date.getDate() + offsetDays)

      const year = date.getFullYear()
      const month = (`0${date.getMonth() + 1}`).slice(-2)
      const day = (`0${date.getDate()}`).slice(-2)

      return `${year}-${month}-${day}`
    },
    assignDerivedDateFields(entry) {
      if (!entry || typeof entry !== 'object') return entry

      if (this.isBlankValue(entry.deleted)) {
        entry.deleted = null
        entry.deletedmin = null
        entry.deletedmax = null
      } else {
        const deletedDate = this.parseDateString(entry.deleted)
        const deletedMs = deletedDate ? deletedDate.getTime() : null
        entry.deletedmin = deletedMs
        entry.deletedmax = deletedMs
      }

      if (this.isBlankValue(entry.validUntil)) {
        entry.validUntil = null
        entry.validmin = null
        entry.validmax = null
      } else {
        const validDate = this.parseDateString(entry.validUntil, true)
        const validMs = validDate ? validDate.getTime() : null
        entry.validmin = validMs
        entry.validmax = validMs
      }

      if (entry.status == null) {
        entry.status = "    "
      }
      if (entry.operator == null) {
        entry.operator = "    "
      }
      if (entry.imei == null) {
        entry.imei = "    "
      }
      if (entry.brand == null) {
        entry.brand = "    "
      }
      if (entry.pricingModel == null) {
        entry.pricingModel = "    "
      }

      return entry
    },
    getAllTeams() {
      const backendAPI = API_ENDPOINTS.TIW_API + "/team/list_all"
      axios.get(backendAPI).then((res) => {
        const teams = Array.isArray(res.data) ? res.data : []
        this.availableTeams = teams
          .filter((team) => team?.uuid != null && getTeamLinkLabel(team).length > 0)
          .map((team) => ({
            ...team,
            teamName: getTeamLinkLabel(team)
          }))
      }).catch(() => {
        this.availableTeams = []
      })
    },
    getValidUntilClass(validUntil) {
      if (this.isBlankValue(validUntil)) return ""

      const validDate = this.parseDateString(validUntil, true)
      if (!validDate) return ""

      const todayStart = new Date()
      todayStart.setHours(0, 0, 0, 0)

      const expiresSoonEnd = new Date(todayStart)
      expiresSoonEnd.setDate(expiresSoonEnd.getDate() + 14)
      expiresSoonEnd.setHours(23, 59, 59, 999)

      const validTime = validDate.getTime()

      if (validTime < todayStart.getTime()) {
        return "sim-valid-expired"
      }

      if (validTime <= expiresSoonEnd.getTime()) {
        return "sim-valid-soon"
      }

      return ""
    },
    getBrandClass(brand) {
      const normalizedBrand = String(brand || "").trim()

      if (normalizedBrand === "Huntloc") return "sim-brand-huntloc"
      if (normalizedBrand === "Doglo") return "sim-brand-doglo"

      return ""
    },
    applyQuickFilter(filterType) {
      this.resetSims()

      if (filterType === 'expiresSoon') {
        this.col.status = 'Active'
        this.col.validmin = this.formatDateOffset(0)
        this.col.validmax = this.formatDateOffset(14)
      } else if (filterType === 'expiredActive') {
        this.col.status = 'Active'
        this.col.validmax = this.formatDateOffset(-1)
      } else if (filterType === 'newActivated') {
        this.col.status = 'New'
        this.col.hasValidUntil = 'true'
      }

      this.filterByColumn()
    },
    showSimDetails(sim) {
      this.selectedSim = sim
      this.popupTriggers.simDetailsTrigger = true
    },
    openOwnerDetails(owner) {
      this.popupTriggers.simDetailsTrigger = false
      this.selectedDeviceOwner = {
        ...owner,
        cellnumber: owner?.cellnumber || owner?.phoneNumber || String(owner?.ownerPhone || '').trim(),
        teamsinfo: Array.isArray(owner?.teamsinfo) ? owner.teamsinfo : [],
        licenses: Array.isArray(owner?.licenses) ? owner.licenses : [],
        devices: Array.isArray(owner?.devices) ? owner.devices : [],
        notes: Array.isArray(owner?.notes) ? owner.notes : []
      }
      this.popupTriggers.userDetailsTrigger = true
    },
    openTeamDetails(teamName) {
      const name = String(teamName || '').trim()
      if (!name) return
      this.popupTriggers.simDetailsTrigger = false
      this.$router.push({ name: 'Teams', query: { team: name } })
    },
    //Adding SIM to pgapi
    AddSIMs() {
      let text = document.getElementById("textarea")
      let lines = text.value.split("\n")
      let alertNumbers = ""
      for (let i = 0; i < lines.length; i++){
        if(lines[i].length > 1){
          let split = lines[i].split(";")
          let sim = {
            phoneNumber: split[0],
            validUntil: split[1],
            status: 'New',
            operator: split[2],
            imei: split[3],
            brand: split[4],
            pricingModel: this.getStoredSimPricingModelSelection(split[5]),
            notes: split[6]
          }
          let API = API_ENDPOINTS.TIW_API + "/sim"
          if (i+1 == lines.length) alertNumbers += sim.phoneNumber + "."
          else alertNumbers += sim.phoneNumber + ", "
          this.assignDerivedDateFields(sim)
          axios.post(API, sim).then(res => {
            this.entries.push(sim)
          })
        }  
      }
      alert("SIM added: "+alertNumbers)
      this.TogglePopup('addSIMTrigger')
      this.paginateData(this.entries);
      this.allPages = $.array.pages(this.entries, this.currentEntries);
    },

    async getAllSims() {
      let backendAPI = API_ENDPOINTS.TIW_API + "/sim/all";
      axios.get(backendAPI).then((res) => {
        this.entries = res.data.map((entry) => this.assignDerivedDateFields(entry));
        this.defaultentries = this.entries;
        this.tempentries = this.entries;
        this.filterentries = this.entries;
        this.deletednull = [];
        this.validnull = [];
        this.deletednotnull = [];
        this.validnotnull = [];
        this.defaultvalidnull = [];
        this.defaultvalidnotnull = [];
        this.defaultdeletednull = [];
        this.defaultdeletednotnull = [];
        for (let i = 0; i < this.entries.length; i++) {
          if (this.entries[i].deleted == null) {
            this.deletednull.push(this.entries[i]);
            this.defaultdeletednull.push(this.entries[i]);
          }
          if (this.entries[i].deleted != null) {
            this.deletednotnull.push(this.entries[i]);
            this.defaultdeletednotnull.push(this.entries[i]);
          }
          if (this.entries[i].validUntil == null) {
            this.validnull.push(this.entries[i]);
            this.defaultvalidnull.push(this.entries[i]);
          }
          if (this.entries[i].validUntil != null) {
            this.validnotnull.push(this.entries[i]);
            this.defaultvalidnotnull.push(this.entries[i]);
          }
        }
        this.csvData = this.entries
        this.lastUpdated = this.formatUpdatedAt()
        this.loaded = true;
        this.paginateData(this.entries);
        this.allPages = $.array.pages(this.entries, this.currentEntries);
      });
    },

    //Download Data as CSV from filtered entries
    downloadCSV() {
      const rows = []
      const data = this.csvData
      const headers = ["id", "phoneNumber", "validUntil", "deleted", "status", "operator", "imei", "brand", "pricingModel", "notes"]
      rows.push(headers.join(";"))

      for (const row of data) {
        const values = headers.map((header) => {
          const rawValue = header === "pricingModel"
            ? this.getSimPricingModelDisplayValue(row)
            : row[header]
          const escaped = ("" + rawValue).replace(/"/g, '\\"')
          if (`"${escaped}"` == '"null"') return '""'
          else return `"${escaped}"`
        })
        rows.push(values.join(";"))
      }
      let csv = rows.join("\n")

      const blob = new Blob([csv], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.setAttribute("hidden", "")
      a.setAttribute("href", url)
      a.setAttribute("download", "Sims.csv")
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },

    resetValid() {
      this.validnull = [];
      for (let i = 0; i < this.defaultvalidnull.length; i++) {
        this.validnull.push(this.defaultvalidnull[i]);
      }
      this.validnotnull = [];
      for (let i = 0; i < this.defaultvalidnotnull.length; i++) {
        this.validnotnull.push(this.defaultvalidnotnull[i]);
      }
    },
    resetDeleted() {
      this.deletednull = [];
      for (let i = 0; i < this.defaultdeletednull.length; i++) {
        this.deletednull.push(this.defaultdeletednull[i]);
      }
      this.deletednotnull = [];
      for (let i = 0; i < this.defaultdeletednotnull.length; i++) {
        this.deletednotnull.push(this.defaultdeletednotnull[i]);
      }
    },
    toggleDeleted() {
      //Toggle
      if (this.hidedeleted == "") {
        this.hidedeleted = "empty";
      } else if (this.hidedeleted == "empty") {
        this.hidedeleted = "full";
      } else if (this.hidedeleted == "full") {
        this.hidedeleted = "";
      }
      this.validnull = [];
      this.validnotnull = [];
      //Entry change
      if (this.hidedeleted == "empty") {
        //entries are values with deleted == null
        this.entries = this.deletednull;
        this.tempentries = this.deletednull;
        this.filterentries = this.deletednull;

        for (let i = 0; i < this.entries.length; i++) {
          //valid null deleted null
          for (let j = 0; j < this.defaultvalidnull.length; j++) {
            if (this.entries[i].id == this.defaultvalidnull[j].id) {
              this.validnull.push(this.defaultvalidnull[j]);
            }
          }

          //valid !null deleted null
          for (let j = 0; j < this.defaultvalidnotnull.length; j++) {
            if (this.entries[i].id == this.defaultvalidnotnull[j].id) {
              this.validnotnull.push(this.defaultvalidnotnull[j]);
            }
          }
        }
      } else if (this.hidedeleted == "full") {
        this.entries = this.deletednotnull;
        this.tempentries = this.deletednotnull;
        this.filterentries = this.deletednotnull;

        for (let i = 0; i < this.entries.length; i++) {
          //valid null deleted !null
          for (let j = 0; j < this.defaultvalidnull.length; j++) {
            if (this.entries[i].id == this.defaultvalidnull[j].id) {
              this.validnull.push(this.defaultvalidnull[j]);
            }
          }

          //valid !null deleted !null
          for (let j = 0; j < this.defaultvalidnotnull.length; j++) {
            if (this.entries[i].id == this.defaultvalidnotnull[j].id) {
              this.validnotnull.push(this.defaultvalidnotnull[j]);
            }
          }
        }
      } else if (this.hidedeleted == "") {
        this.resetValid();
        if (this.hidevalid == "") {
          this.entries = this.defaultentries;
          this.tempentries = this.defaultentries;
          this.filterentries = this.defaultentries;
        } else if (this.hidevalid == "empty") {
          this.entries = this.defaultvalidnull;
          this.tempentries = this.defaultvalidnull;
          this.filterentries = this.defaultvalidnull;
        } else if (this.hidevalid == "full") {
          this.entries = this.defaultvalidnotnull;
          this.tempentries = this.defaultvalidnotnull;
          this.filterentries = this.defaultvalidnotnull;
        }
      }
      this.paginateData(this.entries);
      this.allPages = $.array.pages(this.entries, this.currentEntries);
    },
    toggleValid() {
      //Toggle
      if (this.hidevalid == "") {
        this.hidevalid = "empty";
      } else if (this.hidevalid == "empty") {
        this.hidevalid = "full";
      } else if (this.hidevalid == "full") {
        this.hidevalid = "";
      }
      this.deletednull = [];
      this.deletednotnull = [];
      //Entry change
      if (this.hidevalid == "empty") {
        //entries are values with deleted == null
        this.entries = this.validnull;
        this.tempentries = this.validnull;
        this.filterentries = this.validnull;

        for (let i = 0; i < this.entries.length; i++) {
          //deleted null valid null
          for (let j = 0; j < this.defaultdeletednull.length; j++) {
            if (this.entries[i].id == this.defaultdeletednull[j].id) {
              this.deletednull.push(this.defaultdeletednull[j]);
            }
          }

          //deleted !null valid null
          for (let j = 0; j < this.defaultdeletednotnull.length; j++) {
            if (this.entries[i].id == this.defaultdeletednotnull[j].id) {
              this.deletednotnull.push(this.defaultdeletednotnull[j]);
            }
          }
        }
      } else if (this.hidevalid == "full") {
        this.entries = this.validnotnull;
        this.tempentries = this.validnotnull;
        this.filterentries = this.validnotnull;

        for (let i = 0; i < this.entries.length; i++) {
          //deleted null valid !null
          for (let j = 0; j < this.defaultdeletednull.length; j++) {
            if (this.entries[i].id == this.defaultdeletednull[j].id) {
              this.deletednull.push(this.defaultdeletednull[j]);
            }
          }

          //deleted !null valid !null
          for (let j = 0; j < this.defaultdeletednotnull.length; j++) {
            if (this.entries[i].id == this.defaultdeletednotnull[j].id) {
              this.deletednotnull.push(this.defaultdeletednotnull[j]);
            }
          }
        }
      } else if (this.hidevalid == "") {
        this.resetDeleted();
        if (this.hidedeleted == "") {
          this.entries = this.defaultentries;
          this.tempentries = this.defaultentries;
          this.filterentries = this.defaultentries;
        } else if (this.hidedeleted == "empty") {
          this.entries = this.defaultdeletednull;
          this.tempentries = this.defaultdeletednull;
          this.filterentries = this.defaultdeletednull;
        } else if (this.hidedeleted == "full") {
          this.entries = this.defaultdeletednotnull;
          this.tempentries = this.defaultdeletednotnull;
          this.filterentries = this.defaultdeletednotnull;
        }
      }
      this.paginateData(this.entries);
      this.allPages = $.array.pages(this.entries, this.currentEntries);
    },

    resetEditing() {
      this.tagEditingId = "";
    },
    updateSimNumber(sim) {
      this.tagEditingId = "";
      this.updateSim(sim);
    },
    setTagEditingId(id) {
      this.tagEditingId = id;
      const editedSim = this.entries.find((entry) => entry.id === id)
      if (editedSim) {
        editedSim.pricingModelSelection = this.getSimPricingModelSelectionValue(editedSim)
      }
      setTimeout(() => {
        // document.getElementById('tag-edit-${id}').focus()
      }, 1);
    },
    updateSim(updatedSim) {
      updatedSim.pricingModel = this.getStoredSimPricingModelSelection(updatedSim.pricingModelSelection)
      this.assignDerivedDateFields(updatedSim)
      const payload = {
        ...updatedSim
      }
      delete payload.pricingModelSelection
      let backendAPI = API_ENDPOINTS.TIW_API + "/sim/";
      axios
        .put(backendAPI, payload)
        .then((res) => {
          //Perform Success Action
        })
        .catch((error) => {
          //Error handling
        })
        .finally(() => {
          updatedSim.pricingModelSelection = this.getSimPricingModelSelectionValue(updatedSim)
        });
    },
    removeSIM(id) {
      let answer = confirm("Do you want to delete this SIM?");
      let backendAPI = API_ENDPOINTS.TIW_API + "/sim/" + id;
      if (answer) {
        axios
          .delete(backendAPI, this.sim)
          .then((res) => {
            //Perform Success Action
          })
          .catch((error) => {
            //Error handling
          })
          .finally(() => {
            //action that happens regardless of success/fail
          });
        alert("Sim has been deleted");
      }
    },

    resetSims() {
      (this.hidedeleted = ""),
        (this.hidevalid = ""),
        (this.sortnumber = "default"),
        (this.sortvalid = "default"),
        (this.sortdeleted = "default"),
        (this.entries = this.defaultentries),
        (this.tempentries = this.defaultentries),
        (this.filterentries = this.defaultentries),
        (this.searchEntries = []);
      this.currentPage = 1;
      this.searchInput = "";
      this.resetEditing();
      (this.col = {
        phoneNumber: "",
        validmin: "",
        validmax: "",
        hasValidUntil: "",
        deletedmin: "",
        deletedmax: "",
        status: "",
        operator: "",
        imei: "",
        brand: "",
        pricingModel: "",
        notes: "",
      }),
        this.paginateEntries();
    },
    paginateEntries() {
      if (this.searchInput.length >= 1) {
        this.searchEntries = $.array.search(this.entries, this.searchInput);
        this.paginateData(this.searchEntries);
      } else {
        this.searchEntries = [];
        this.paginateData(this.entries);
      }
      this.csvData = this.filteredEntries
    },
    paginateEvent(page) {
      this.currentPage = page;
      this.paginateEntries();
    },
    searchEvent() {
      (this.sortnumber = "default"),
        (this.sortvalid = "default"),
        (this.sortdeleted = "default"),
        (this.currentPage = 1);
      this.paginateEntries();
    },
    paginateData(data) {
      this.filteredEntries = $.array.paginate(
        data,
        this.currentPage,
        this.currentEntries
      );
      this.allPages = $.array.pages(data, this.currentEntries);
    },
    getCurrentEntries() {
      return this.searchEntries.length <= 0 ? this.entries : this.searchEntries;
    },
    filterByColumn() {
      this.resetSortIcon();
      this.currentPage = 1;
      this.entries = this.tempentries;
      const filterCol = $.object.removeBy(this.col, "");
      let filterData = this.getCurrentEntries();
      if (Object.entries(filterCol).length >= 1) {
        filterData = this.filter(filterCol);
      }
      this.entries = filterData;
      this.filterentries = this.entries;
      this.resetSortLogic();
      this.paginateData(this.entries);
      this.allPages = $.array.pages(this.entries, this.currentEntries);
    },
    resetSortIcon() {
      (this.sortnumber = "default"),
        (this.sortdeleted = "default"),
        (this.sortvalid = "default");
    },
    resetSortLogic() {
      this.sortcol["phoneNumber"] = "";
      this.sortcol["validUntil"] = "";
      this.sortcol["deleted"] = "";
    },
    sortByColumn(column) {
      let sortedEntries = this.getCurrentEntries();
      let sortedColumn = this.sortcol[column];
      if (sortedColumn === "") {
        this.sortcol[column] = "asc";
        if (column == "phoneNumber") {
          this.sortnumber = "asc";
        } else if (column == "validUntil") {
          this.sortvalid = "asc";
        } else if (column == "deleted") {
          this.sortdeleted = "asc";
        }
        sortedEntries = $.array.sortBy(this.getCurrentEntries(), column, "asc");
        this.entries = sortedEntries;
      } else if (sortedColumn === "asc") {
        this.sortcol[column] = "desc";
        if (column == "phoneNumber") {
          this.sortnumber = "desc";
        } else if (column == "validUntil") {
          this.sortvalid = "desc";
        } else if (column == "deleted") {
          this.sortdeleted = "desc";
        }
        sortedEntries = $.array.sortBy(
          this.getCurrentEntries(),
          column,
          "desc"
        );
        this.entries = sortedEntries;
      } else if (sortedColumn === "desc") {
        this.sortcol[column] = "";
        if (column == "phoneNumber") {
          this.sortnumber = "default";
        } else if (column == "validUntil") {
          this.sortvalid = "default";
        } else if (column == "deleted") {
          this.sortdeleted = "default";
        }
        this.entries = this.filterentries;
      }
      this.paginateData(this.entries);
    },
    filter(filterObj) {
      let filteredArray = Array.from(this.getCurrentEntries());
      for (let [key, val] of Object.entries(filterObj, "", 0)) {
        const filterfromArr = filteredArray.filter((obj) => {
          if (key === "hasValidUntil") {
            return val === "true" ? !this.isBlankValue(obj.validUntil) : true
          }
          if (key === "pricingModel") {
            const pricingModelDisplay = this.getSimPricingModelDisplayValue(obj)
            if (val === "__EMPTY__") return this.isBlankValue(pricingModelDisplay)
            return pricingModelDisplay.toLowerCase().includes(String(val).toLowerCase())
          }
          if (key in obj) {
            //filtering strings
            if (!key.includes("min") && !key.includes("max")) {
              if (obj[key] == Number(val)) return true;
              else if (obj[key] && obj[key].toLowerCase().includes(val.toLowerCase())) return true;
            }
            if (key.includes("min") || key.includes("max")) {
              //dates
              if (val.length >= 4) {
                let date, yyyy, valms, value;
                if (val.includes("-")) {
                  valms = val.split("-");
                  yyyy = valms[0];
                  if (valms[1] != "" && valms[1] != null) {
                    let mm;
                    if (valms[1].length < 2) mm = "0" + valms[1];
                    else mm = valms[1];
                    if (valms[2] != "" && valms[2] != null) {
                      let dd;
                      if (valms[2].length < 2) dd = "0" + valms[2];
                      else dd = valms[2];
                      date = new Date([yyyy, mm, dd].join("-"));
                    } else {
                      date = new Date([yyyy, mm].join("-"));
                    }
                  } else {
                    date = new Date(yyyy);
                  }
                } else {
                  yyyy = val;
                  date = new Date(yyyy);
                }
                let object = Number(obj[key]);
                if (key.includes("min")) {
                  value = date.getTime();
                  if (object >= value) {
                    return true;
                  }
                } else if (key.includes("max")) {
                  value = date.getTime() + 86400000;
                  if (object <= value) {
                    return true;
                  }
                }
              }
            }
          }
          return false;
        });
        filteredArray = filterfromArr;
      }
      this.csvData = filteredArray
      return filteredArray;
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: unset !important;
}
th,
td,
tr,
select,
input,
body {
  font-size: 10px;
}
button {
  font-size: 10px;
}
.table-filter-label,
.table-column-toggle {
  font-size: 10px;
}
.table-column-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.sims-list-view { padding: 4px 18px 18px; color: #202629; }
.sims-list-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin: 0 -18px 18px; padding: 20px 22px; border-left: 4px solid #f56600; border-radius: 0 0 9px 9px; background: #202629; color: #fff; }
.sims-list-header h1 { margin: 0; font-size: 22px; font-weight: 700; }
.sims-list-header-updated { color: #c8d0d3; font-size: 11px; font-style: italic; }
.add-sims-dialog { width: min(96vw, 720px); padding: 4px; color: #202629; }
.add-sims-header { margin-bottom: 18px; padding: 20px; border-left: 4px solid #f56600; border-radius: 9px; background: #202629; color: #fff; }
.add-sims-header h2 { margin: 0; font-size: 22px; font-weight: 700; }
.add-sims-section { padding: 14px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.add-sims-section label { display: block; margin-bottom: 5px; color: #202629; font-size: 11px; font-weight: 700; }
.add-sims-section p { margin: 0 0 10px; color: #687277; font-size: 11px; }
.add-sims-input { min-height: 200px; resize: vertical; font-size: 11px; }
.add-sims-input:focus { border-color: #f56600; box-shadow: 0 0 0 .15rem rgba(245, 102, 0, .16); }
.add-sims-actions { display: flex; justify-content: flex-end; margin-top: 10px; }
.add-sims-submit { border: 1px solid #f56600; background: #f56600; color: #fff; font-size: 10px; }
.add-sims-submit:hover { border-color: #d95700; background: #d95700; color: #fff; }
.sims-list-toolbar { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 12px; padding: 12px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.sims-list-page-size { display: flex; align-items: center; gap: 7px; flex: 0 0 auto; }
.sims-list-page-size label { color: #40545e; font-size: 10px; font-weight: 700; text-transform: uppercase; }
.sims-list-page-size select { width: 64px; font-size: 10px; font-weight: 700; }
.sims-list-actions { display: flex; flex: 1; flex-wrap: wrap; justify-content: flex-end; gap: 7px; }
.sims-list-actions .btn { margin: 0; font-size: 10px; }
.sims-list-secondary { border: 1px solid #d7dfe2; background: #fff; color: #202629; }
.sims-list-secondary:hover { border-color: #f56600; color: #f56600; }
.sims-list-primary { border: 1px solid #f56600; background: #f56600; color: #fff; font-size: 10px; }
.sims-list-primary:hover { border-color: #d95700; background: #d95700; color: #fff; }
.sims-list-new { border-color: #f56600; background: #f56600; color: #fff; }
.sims-list-new:hover { border-color: #d95700; background: #d95700; color: #fff; }
.sims-list-search { width: 180px; height: 29px; color: #202629; }
.sims-list-columns { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 12px; margin-bottom: 12px; padding: 10px 12px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.sims-list-columns .table-filter-label { margin: 0; color: #40545e; font-weight: 700; text-transform: uppercase; }
.sims-list-table-wrap { overflow-x: auto; border: 1px solid #e1e5e6; border-radius: 9px; background: #fff; }
.sims-data-table { min-width: 1250px; margin-bottom: 0; }
.sims-data-table thead { background: #f1f4f5; }
.sims-data-table th, .sims-data-table td { padding: 9px 10px; vertical-align: middle; border-color: #e1e5e6; }
.sims-data-table thead th { color: #40545e; font-size: 10px; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; }
.sims-data-table tbody tr:last-child > * { border-bottom: 0; }
@media (max-width: 700px) {
  .sims-list-view { padding: 4px 10px 12px; }
  .sims-list-header { margin: 0 -10px 14px; padding: 16px; }
  .add-sims-dialog { width: calc(100vw - 24px); }
  .add-sims-header { padding: 16px; }
  .sims-list-toolbar { flex-direction: column; }
  .sims-list-actions { justify-content: flex-start; }
  .sims-list-search { width: 100%; }
}
.nav-link {
  font-size: 8px;
}
.stopped {
  background-color: yellow;
}
.closed {
  background-color: salmon;
}
.bi:hover {
  color: darkblue;
  cursor: pointer;
}
.search {
  font-weight: bold;
  color: orangered;
}
.form-search {
  background-color: salmon;
  font-weight: bold;
}
.sim-valid-expired,
.sim-valid-soon,
.sim-brand-huntloc,
.sim-brand-doglo {
  display: inline-block;
  min-width: 72px;
  padding: 2px 6px;
  border-radius: 999px;
  text-align: center;
}
.sim-valid-expired {
  background-color: salmon;
  color: #000;
}
.sim-valid-soon {
  background-color: #ffe066;
  color: #000;
}
.sim-brand-huntloc {
  background-color: #ff9a00;
  color: #000;
}
.sim-brand-doglo {
  background-color: #000;
  color: #fff;
}
.sims-data-table.hide-column-validUntil tr > :nth-child(2),
.sims-data-table.hide-column-deleted tr > :nth-child(3),
.sims-data-table.hide-column-status tr > :nth-child(4),
.sims-data-table.hide-column-operator tr > :nth-child(5),
.sims-data-table.hide-column-imei tr > :nth-child(6),
.sims-data-table.hide-column-brand tr > :nth-child(7),
.sims-data-table.hide-column-pricingModel tr > :nth-child(8),
.sims-data-table.hide-column-notes tr > :nth-child(9),
.sims-data-table.hide-column-actions tr > :nth-child(10) {
  display: none !important;
}
.device-owner-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
}
.device-owner-loading-card {
  min-width: 220px;
  padding: 28px 36px;
  text-align: center;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}
.device-owner-loading-card .spinner-border {
  width: 2rem;
  height: 2rem;
  margin-bottom: 12px;
}
.device-owner-loading-card p {
  margin: 0;
}
/* clears the 'X' from Internet Explorer */
input[type="search"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
input[type="search"]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the 'X' from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
